import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import {
  damageTypeValuesDict,
  noCostCenter,
  vehicleNatureValuesDict,
  vehicleNatureValuesDictGerman,
} from './../../../types/constants'
import Modal from './../../common/Modal/Modal'
import './ContractsDropDownFilterModal.scss'
import { CarDamageValue, VehicleNatureValue } from '../../../types/enums'

interface IContractsDropDownFilterModalProps extends WithTranslation {
  onClose: () => void
  filterChanged: (items: string[]) => void
  allItems: string[]
  currentFilter: string[]
  visible: boolean
  title: string
  translationPrefix?: string
}

interface IContractsDropDownFilterModalState {
  searchString: string
  searchResults: string[]
  showAll: boolean
  showLoader: boolean
}

class ContractsDropDownFilterModal extends Component<
  IContractsDropDownFilterModalProps,
  IContractsDropDownFilterModalState
> {
  private searchInput?: HTMLInputElement
  constructor(props: IContractsDropDownFilterModalProps) {
    super(props)

    this.state = {
      searchString: '',
      searchResults: [],
      showAll: false,
      showLoader: false,
    }
  }
  render() {
    const { t, visible, title, currentFilter, allItems, translationPrefix } = this.props
    const { searchString, searchResults, showAll } = this.state
    return (
      <Modal
        title={title}
        visible={visible}
        onClose={() => {
          this.props.onClose()
        }}
      >
        <div className="contracts-dropdown-filter-ui">
          {currentFilter?.length > 0 && (
            <div className="active-items">
              {currentFilter?.map((item, idx) => (
                <span key={idx}>
                  <span>
                    {translationPrefix
                      ? t(`${translationPrefix}${item}`.toUpperCase())
                      : this.props.title === t('OBJ_TYPE') ||
                        this.props.title === t('DAMAGE_TYPE') ||
                        this.props.title === t('INCIDENT_STATUS') ||
                        this.props.title === t('END_INTENTION_SEARCH') ||
                        this.props.title === t('ORDER_STATUS_SEARCH') ||
                        this.props.title === t('RETURN_STATUS_SEARCH')
                      ? t(`${item}`.toUpperCase())
                      : item}{' '}
                  </span>
                  <i className="icon-close" onClick={() => this.updateFilter(item, true)} />
                </span>
              ))}
            </div>
          )}
          <div className="search">
            <input
              autoFocus={true}
              type="text"
              value={searchString}
              name={`fieldnameveryunique${new Date().getTime()}`}
              autoComplete="none"
              list="autocompleteOff"
              placeholder={t('KEYWORDS')}
              onChange={(e) => this.makeComapnyFilerSearchResults(e)}
              onClick={() => this.handleInputClick()}
              ref={(inputEl) => (this.searchInput = inputEl ?? undefined)}
            />
            <i
              className="icon-bottom"
              onClick={() => {
                this.showAll()
              }}
            />
            {this.state.showLoader ? <div className="loader"></div> : null}{' '}
          </div>
          {(showAll || searchResults.length > 0) && (
            <div className="search-results">
              <ul>
                {(showAll ? allItems : searchResults)
                  .filter((c) => currentFilter && currentFilter.indexOf(c) < 0)
                  .map((c, idx) => (
                    <li key={idx} onClick={() => this.updateFilter(c)}>
                      {allItems && this.props.title === t('MAKES') ? (
                        <img
                          src={`../../../../../BW/${
                            c.toLowerCase().indexOf('ladestation') > -1
                              ? 'dummy'
                              : c
                                  .normalize('NFD')
                                  .replace(/[\u0300-\u036f]/g, '')
                                  .replace(/\s+/g, '-')
                                  .toLowerCase()
                          }.svg`}
                          width="40"
                          height="40"
                        />
                      ) : this.props.title === t('OBJ_TYPE') || this.props.title === t('DAMAGE_TYPE') ? (
                        <i
                          style={{ fontSize: 'xx-large' }}
                          className={
                            this.props.title === t('OBJ_TYPE')
                              ? this.getVehicleNatureValue(c) || this.getGermanVehicleNatureValue(c) || 'icon-4u'
                              : this.props.title === t('DAMAGE_TYPE')
                              ? this.getDamageNatureValue(c)
                              : undefined
                          }
                        />
                      ) : null}
                      <span className="name">
                        {c === noCostCenter
                          ? t('NO_COST_CENTER')
                          : translationPrefix
                          ? t(`${translationPrefix}${c}`.toUpperCase())
                          : this.props.title === t('OBJ_TYPE') ||
                            this.props.title === t('DAMAGE_TYPE') ||
                            this.props.title === t('INCIDENT_STATUS') ||
                            this.props.title === t('END_INTENTION_SEARCH') ||
                            this.props.title === t('ORDER_STATUS_SEARCH') ||
                            this.props.title === t('RETURN_STATUS_SEARCH')
                          ? t(`${c}`.toUpperCase())
                          : c}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    )
  }

  private handleInputClick() {
    if (this.state.searchResults.length === 0) {
      this.setState({
        showAll: true,
      })
    }
  }

  private showAll() {
    this.setState({
      showAll: !this.state.showAll,
    })

    this.searchInput?.focus()
  }

  private updateFilter(item: string, remove?: boolean) {
    this.setState({ showLoader: true })
    const items = [...(this.props.currentFilter || [])]
    if (remove) {
      const idx = items.indexOf(item)
      if (idx > -1) {
        items.splice(idx, 1)
      }
    } else {
      items.push(item)
    }

    setTimeout(() => {
      this.props.filterChanged(items)
      this.makeComapnyFilerSearchResults()
      this.setState({ showLoader: false })
    }, 700)
  }

  private makeComapnyFilerSearchResults(e?: React.ChangeEvent<HTMLInputElement>) {
    const found = []
    const plainValue = e ? e.target.value || '' : ''
    if (e) {
      const search = plainValue.trim().toLowerCase()
      found.push(...(search ? this.props.allItems.filter((c) => c.toLowerCase().indexOf(search) > -1) : []))
    }

    this.setState({
      searchString: plainValue,
      searchResults: found,
      showAll: false,
    })

    this.searchInput?.focus()
  }
  private getVehicleNatureValue(key: string): VehicleNatureValue | undefined {
    return vehicleNatureValuesDict[key as keyof typeof vehicleNatureValuesDict]
  }
  private getGermanVehicleNatureValue(key: string): VehicleNatureValue | undefined {
    return vehicleNatureValuesDictGerman[key as keyof typeof vehicleNatureValuesDictGerman]
  }
  private getDamageNatureValue(key: string): CarDamageValue | undefined {
    return damageTypeValuesDict[key as keyof typeof damageTypeValuesDict]
  }
}

export default withTranslation('common')(ContractsDropDownFilterModal)
